import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import { jobsRoute } from '../../routes';

import css from './listing.scss';

export default class JobListing extends Component {
	static propTypes = {};

	render() {
		let className = 'job-listing';
		let isSmall = this.props.listStyle === 1;

		if (isSmall) {
			className += ' job-listing--small';
		}

		return (
			<Link to={jobsRoute(this.props.job.slug)} className={className} onClick={() => {
				this.props.dispatch({ type: 'MENU_CLOSE' });
			}}>
				<div className='job-listing__title'>{this.props.job.title}</div>
				{ isSmall && (
					<div className='job-listing__location'>{this.props.job.profileName} {this.props.job.location}</div>
				)}

				{ !isSmall && (
					<div>
						<div className='job-listing__profile'>{this.props.job.profileName}</div>
						<div className='job-listing__posted'>{this.props.job.postedDate}</div>
						<div className='job-listing__location'>{this.props.job.location}</div>
					</div>
				)}
			</Link>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/jobs/listing.js
 **/